(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.istine-countdown').forEach(function (el) {
    var target = new Date(el.dataset.target).getTime();
    if (isNaN(target)) return;
    var q = function (k) { return el.querySelector('[data-cd="' + k + '"]'); };
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        ['days', 'hours', 'mins', 'secs'].forEach(function (k) { q(k).textContent = '00'; });
        return;
      }
      q('days').textContent = pad(Math.floor(diff / 86400000));
      q('hours').textContent = pad(Math.floor((diff % 86400000) / 3600000));
      q('mins').textContent = pad(Math.floor((diff % 3600000) / 60000));
      q('secs').textContent = pad(Math.floor((diff % 60000) / 1000));
      setTimeout(tick, 1000);
    }
    tick();
  });
  } catch(e) { console.error(e); }
})();

})();
